module.exports = __webpack_public_path__ + "img/Scratch.81ff4609.png";